import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-workflow-flow_svg__a"
        d="M14.857 4.857H10C9.524 3.238 8.095 2 6.286 2a3.82 3.82 0 00-3.81 3.81 3.82 3.82 0 003.81 3.809c1.81 0 3.238-1.238 3.714-2.857h4.857c2.667 0 4.762 2.095 4.762 4.762 0 1.714-.857 3.238-2.286 4.095-.571-1.333-1.904-2.19-3.428-2.19-1.81 0-3.238 1.238-3.715 2.857h-.476c-2.666 0-4.762 2.19-4.762 4.762h1.905c0-1.62 1.333-2.858 2.857-2.858h.476c.381 1.62 1.905 2.858 3.715 2.858 2 0 3.619-1.524 3.81-3.524 2.285-1.048 3.809-3.429 3.809-6a6.626 6.626 0 00-6.667-6.667zM6.286 7.714A1.91 1.91 0 014.38 5.81a1.91 1.91 0 011.905-1.905A1.91 1.91 0 018.19 5.81a1.91 1.91 0 01-1.904 1.904zm7.619 11.429A1.91 1.91 0 0112 17.238a1.91 1.91 0 011.905-1.905 1.91 1.91 0 011.905 1.905 1.91 1.91 0 01-1.905 1.905z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-workflow-flow_svg__a"
    />
  </svg>
);
